import { createReducer, on, Action } from '@ngrx/store';
import { ApiError, Basket } from '../../client/src';
import { LoadState } from '@nx-ng/types';
import { CheckoutActions } from '../../actions';
import { BASKET_ID_KEY } from '@nx-ng/constants';
import { updateLocalStorageItem } from '@nx-ng/util';

export interface ICheckoutState {
  basket?: Basket;
  loaded: LoadState;
  error?: ApiError | string;
}

export const initialState: ICheckoutState = {
  loaded: LoadState.NOT_LOADED,
};

const basketReducer = createReducer(
  initialState,
  on(CheckoutActions.checkoutAPI_loadBasket, (state) => ({
    ...state,
    loaded: LoadState.LOADING,
    error: undefined,
  })),
  on(
    CheckoutActions.checkoutAPI_loadBasketSuccess,
    (state, { basket }: { basket: Basket }) => ({
      ...state,
      basket,
      loaded: LoadState.LOADED,
    })
  ),
  on(CheckoutActions.checkoutAPI_loadBasketFailure, (state, { error }) => ({
    ...state,
    error,
    loaded: LoadState.FAILED,
  })),
  on(CheckoutActions.updateBasketItemQuantity, (state) => ({
    ...state,
    loaded: LoadState.LOADING,
    error: undefined,
  })),

  on(CheckoutActions.checkoutAPI_removeBasketSuccess, (state) => ({
    ...state,
    basket: undefined,
    loaded: LoadState.LOADED,
  })),
  on(
    CheckoutActions.checkoutAPI_updateBasketSuccess,
    (state, { basket }: { basket: Basket }) => ({
      ...state,
      basket,
      loaded: LoadState.LOADED,
    })
  ),
  on(CheckoutActions.checkoutAPI_updateBasketFailure, (state, { error }) => ({
    ...state,
    error,
    loaded: LoadState.FAILED,
  }))
);

export function reducer(state: ICheckoutState | undefined, action: Action) {
  const newState = basketReducer(state, action);

  if (newState.basket && !state?.basket) {
    updateLocalStorageItem(BASKET_ID_KEY, newState.basket.basketId);
  } else if (!newState.basket && state?.basket) {
    updateLocalStorageItem(BASKET_ID_KEY, undefined);
  }
  return newState;
}
